var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoyner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_39",
    "data-name": "Group 39",
    xmlns: "http://www.w3.org/2000/svg",
    width: 166,
    height: 166,
    viewBox: "0 0 166 166",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_43108",
    "data-name": "Group 43108"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    "data-name": "Fill 1",
    d: "M83,166a82.612,82.612,0,0,1-46.406-14.175A83.243,83.243,0,0,1,6.523,115.307a82.89,82.89,0,0,1,7.653-78.713A83.243,83.243,0,0,1,50.693,6.523a82.891,82.891,0,0,1,78.713,7.652,83.24,83.24,0,0,1,30.071,36.517,82.892,82.892,0,0,1-7.652,78.713,83.24,83.24,0,0,1-36.517,30.071A82.482,82.482,0,0,1,83,166ZM83,16.014A66.986,66.986,0,1,0,149.986,83,67.062,67.062,0,0,0,83,16.014Z",
    fill: "#ea6012"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill_3",
    "data-name": "Fill 3",
    d: "M38.695,92H0V0H37.136A38.655,38.655,0,0,1,49.228,1.744a24.162,24.162,0,0,1,9.009,5.233,22.471,22.471,0,0,1,5.6,8.2A28.9,28.9,0,0,1,65.7,25.843,20.81,20.81,0,0,1,64.6,32.819a21.347,21.347,0,0,1-2.856,5.492,22.908,22.908,0,0,1-3.766,4.071,17.259,17.259,0,0,1-3.7,2.456,32.95,32.95,0,0,1,4.351,2.648,18.509,18.509,0,0,1,4.09,4.071,23.022,23.022,0,0,1,3.052,5.879A24,24,0,0,1,67,65.511a29.145,29.145,0,0,1-2.076,11.371,22.94,22.94,0,0,1-5.844,8.269,25.536,25.536,0,0,1-8.959,5.1A35.858,35.858,0,0,1,38.695,92ZM18.049,53.365V75.978H36.877a15.764,15.764,0,0,0,5.4-.84,8.982,8.982,0,0,0,3.75-2.521,11.852,11.852,0,0,0,2.92-8.01,11.616,11.616,0,0,0-2.92-7.947c-1.94-2.187-5.02-3.3-9.155-3.3Zm0-37.342v21.19H35.707c3.878,0,6.871-.978,8.9-2.907a10.176,10.176,0,0,0,3.051-7.689A10.168,10.168,0,0,0,44.6,18.931c-2.025-1.93-5.018-2.908-8.9-2.908Z",
    transform: "translate(52 37)",
    fill: "#ea6012"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoyner);
export default __webpack_public_path__ + "static/media/boyner.c1f622acd89e3e869c6a467606e8b98b.svg";
export { ForwardRef as ReactComponent };